import { render, staticRenderFns } from "./PersonalAuthorityManagement.vue?vue&type=template&id=d10d5f00&scoped=true&"
import script from "./PersonalAuthorityManagement.vue?vue&type=script&lang=js&"
export * from "./PersonalAuthorityManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10d5f00",
  null
  
)

export default component.exports